(() => {
  'use strict';
  function update(scope=document) {
    scope.querySelectorAll('[data-ol-progress]').forEach(bar => {
      const milestones=[...bar.querySelectorAll('[data-ol-milestone]')];
      milestones.forEach(item=>item.hidden=false);
      if(bar.dataset.mode!=='next') return;
      const next=milestones.filter(item=>Number(item.dataset.remaining)>0).sort((a,b)=>Number(a.dataset.remaining)-Number(b.dataset.remaining))[0];
      const highest=milestones.slice().sort((a,b)=>Number(b.dataset.threshold)-Number(a.dataset.threshold))[0];
      const visible=next||highest;
      milestones.forEach(item=>item.hidden=item!==visible);
    });
  }
  document.addEventListener('ol:cart-rendered',()=>update());
  document.addEventListener('shopify:section:load',event=>update(event.target));
  update();
})();
